import { createAction, props } from '@ngrx/store';

export const checkAuth = createAction(
    '[Auth] Check Auth',
    props<{ force?: boolean }>()
);

export const setAccessToken = createAction(
    '[Auth] Set Access Token',
    props<{ accessToken: string | null }>()
);

export const setActor = createAction(
    '[Auth] Set Actor',
    props<{ actor: any | null }>()
);

export const checkAuthSuccess = createAction(
    '[Auth] Check Authentication Success',
    props<{ isAuthenticated: boolean }>()
);

export const checkAuthFailure = createAction(
    '[Auth] Check Authentication Failure',
    props<{ error: string }>()
);

export const loadCurrentUser = createAction('[Auth] Load Current User');

export const loadCurrentUserSuccess = createAction(
    '[Auth] Load Current User Success',
    props<{ user: any }>()
);

export const loadCurrentUserFailure = createAction(
    '[Auth] Load Current User Failure',
    props<{ error: string }>()
);

export const signOut = createAction(
    '[Auth] Sign Out',
    props<{ redirectTo?: string }>()
);

export const signOutSuccess = createAction('[Auth] Sign Out Success');

export const clearAuthState = createAction('[Auth] Clear Auth State');

export const redirectToLogin = createAction(
    '[Auth] Redirect to Login',
    props<{ returnUrl?: string }>()
);

export const sessionExpired = createAction(
    '[Auth] Session Expired',
    props<{ returnUrl?: string }>()
);
